
const ReportElementTypeEnum = {
  BAR_CHART: 1,
  PIE_CHART: 2,
  BAR_CHART_NPS_IMPROVE: 3,
  PIE_CHART_NPS: 4,
  PIE_CHART_PROMOTERS: 5,
  // Add more values as needed
};
export const BarChartTypes = [ReportElementTypeEnum.BAR_CHART, ReportElementTypeEnum.BAR_CHART_NPS_IMPROVE];
export const PieChartTypes = [ReportElementTypeEnum.PIE_CHART, ReportElementTypeEnum.PIE_CHART_NPS,ReportElementTypeEnum.PIE_CHART_PROMOTERS];